export const CHECK_USER_PROFILE_ONCE_A_DAY_KEY = "CheckUserProfileOnceADay";
export const LATEST_UPDATE_AT_KEY = "LatestUpdateAt";
